<template>
	<el-dialog :title="title ? title : '证书信息'" class="customDialog attestationDialog" :visible="show" width="800px"
		:close-on-click-modal="false" append-to-body :before-close="closedBtn">
		<div class="info_left" v-if="!overOnLine">
			<div class="tree_box">
				<h3>证书路径</h3>
				<el-tree :expand-on-click-node="false" ref="tree" :data="data" node-key="id" :highlight-current="true"
					:current-node-key="currentLivingId" :props="defaultProps" @node-click="handleNodeClick">
					<template #default="{ node }">
						<el-tooltip effect="light" :content="node.label" placement="top">
							<span class="tree-text"> {{ node.label }}</span>
						</el-tooltip>
					</template></el-tree>
			</div>
			<div class="bottom_info">
				<p class="info_msg sucess"><i></i>选定的证书路径有效</p>
				<p v-if="!sealInfo.parentId">路径验证于以下签名时间已完成：</p>
				<p v-else>路径验证和吊销检查于以下签名时间已完成：{{ timeInfo }}</p>
				<p v-if="!sealInfo.parentId">{{ timeInfo }}</p>
			</div>
		</div>
		<div class="dialog_main" :class="{ active: title }">
			<div class="tab_box">
				<div class="tab_item" @click="clickTab(index)" :class="{ active: activeName == index }"
					v-for="(item, index) in tabList" :key="index">
					{{ item }}
				</div>
			</div>
			<div class="certificate_main" v-if="activeName == 0">
				<div class="info_box certificate_info">
					<ul>
						<li>
							<div class="info_lable">颁发者：</div>
							<div class="info_content">{{ sealInfo.issuerInfo ? sealInfo.issuerInfo.commonName : "" }}</div>
						</li>
						<li>
							<div class="info_lable">使用者：</div>
							<div class="info_content">{{ sealInfo.subjectInfo ? sealInfo.subjectInfo.commonName : "" }}
							</div>
						</li>
						<li>
							<div class="info_lable">有效时间：</div>
							<div class="info_content">从&nbsp;{{ sealInfo.startTime }}&nbsp;到&nbsp;{{ sealInfo.endTime }}
							</div>
						</li>
						<li>
							<div class="info_lable">指纹：</div>
							<div class="info_content">{{ sealInfo.hashValue }}</div>
						</li>
						<li>
							<div class="info_lable" v-if="!overOnLine">预期用途：</div>
							<div class="info_content">{{ keyUsage(sealInfo.keyUsage) +
								enhancedKeyUsage(sealInfo.enhancedKeyUsage) }}</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="certificate_main" v-if="activeName == 1">
				<div class="info_box certificate_info" style="height: 321px;">
					<ul>
						<li @click="showInfoClick(sealInfo.version)">
							<div class="info_lable">版本：</div>
							<div class="info_content">{{ sealInfo.version }}</div>
						</li>
						<li @click="showInfoClick(sealInfo.serial)">
							<div class="info_lable">序列号：</div>
							<div class="info_content">{{ sealInfo.serial }}</div>
						</li>
						<li @click="showInfoClick(sealInfo.signatureAlg)">
							<div class="info_lable">签名算法：</div>
							<div class="info_content">{{ sealInfo.signatureAlg }}</div>
						</li>
						<li @click="showInfoClick(sealInfo.signatureHashAlg)">
							<div class="info_lable">签名哈希算法：</div>
							<div class="info_content">{{ sealInfo.signatureHashAlg }}</div>
						</li>
						<li @click="showInfoClick(sealInfo.pubkey)">
							<div class="info_lable">公钥：</div>
							<div class="info_content">{{ sealInfo.pubkey }}</div>
						</li>
					</ul>
				</div>
				<div class="time_box">{{ clickInfo }}</div>
			</div>
			<div class="certificate_main" v-if="activeName == 2 && !overOnLine">
				<p class="info_msg error" v-if="!sealInfo.parentId"><i></i>没有进行吊销检查</p>
				<p class="info_msg sucess" v-else-if="sealInfo.crlerrCode == 0"><i></i>选定的证书路径有效</p>
				<p class="info_msg faild" v-else><i></i>选定的证书路径无效</p>
				<div class="info_box certificate_info info_diaoxiao" v-if="!sealInfo.parentId">
					<p>选定的证书为信任锚或或在证书链中信任锚之上，因此不会执行吊销检查。</p>
				</div>
				<div class="info_box certificate_info info_diaoxiao" v-else>
					<p v-if="sealInfo.crlerrCode == 0">选定的证书有效，未出现在嵌入签名的“证书吊销列表（CRL）”中</p>
					<p v-else>选定的证书无效，已出现在嵌入签名的“证书吊销列表（CRL）”中。</p>
					<ul>
						<li>
							<div class="info_lable">CRL签名方：</div>
							<div class="info_content">{{ sealInfo.crlsigner ? sealInfo.crlsigner : "" }}</div>
						</li>
						<li>
							<div class="info_lable">签名时间：</div>
							<div class="info_content">{{ sealInfo.lastTime ? sealInfo.lastTime : "" }}</div>
						</li>
						<li>
							<div class="info_lable">有效期至：</div>
							<div class="info_content">{{ sealInfo.nextTime ? sealInfo.nextTime : "" }}</div>
						</li>
					</ul>
					<div class="info_bottom">
						<p v-if="sealInfo.parentId">点击“签名者详情信息”可查看吊销信息来源</p>
						<div class="botton">
							<span @click="activeName = 1">签名者详情信息</span>
						</div>
					</div>
				</div>

			</div>
			<div class="certificate_main" v-if="activeName == activeNameLine">
				<div class="info_box">
					<p>验证电子印章的文档需要使用独立的第三方服务提供商提供的数字证书相关服务。</p>
					<p>对电子印章文档、创建电子印章文档的证书及相关服务，由第三方服务提供商来保障。</p>
					<p>请详阅颁发者证书信息。</p>
					<p>本程序显示的签章、签名和证书相关时间均为北京时间。</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" style="text-align: right;">
				<el-button @click="closedBtn" size="small">&ensp;关闭&ensp;</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import { arrayToTree } from "@comm/utils/tools";
const keyUsageList = [
	{ id: "Digital Signature", name: "数字签名" },
	{ id: "Non-Repudiation", name: "不可否认" },
	{ id: "Key Encipherment", name: "密钥加密" },
	{ id: "Data Encipherment", name: "数据加密" },
	{ id: "Key Agreement", name: "密钥协商" },
	{ id: "KCertificate Signature", name: "证书签名" },
	{ id: "CRL Signature", name: "CRL签名" },
	{ id: "encipherOnly", name: "仅加密" },
	{ id: "decipherOnly", name: "仅解密" }
]
const enhancedKeyUsageList = [
	{ id: "1.3.6.1.5.5.7.3.1", name: "服务器身份认证" },
	{ id: "1.3.6.1.5.5.7.3.2", name: "客户端身份认证" },
	{ id: "1.3.6.1.5.5.7.3.3", name: "代码签名" },
	{ id: "1.3.6.1.5.5.7.3.4", name: "安全电子邮件" },
	{ id: "1.3.6.1.5.5.7.3.8", name: "时间戳" },
	{ id: "1.3.6.1.5.5.7.3.9", name: "OCSP" }
]
export default {
	name: "certificateInfo",
	props: {
		show: { type: Boolean, default: false },
		title: { type: String, default: "" },
		sealInfoList: { type: Array, default: () => [] },
		timeInfo: { type: String, default: "" },
		overOnLine: { type: Boolean, default: false },
	},
	data() {
		return {
			key: "value",
			clickInfo: "",
			activeName: 0,
			activeTab: 0,
			sealInfo: {
				issuerInfo: null,
				subjectInfo: null,
				start: "",
				end: "",
				hashValue: "",
				version: "",
				serial: "",
				signatureAlg: "",
				signatureHashAlg: "",
				pubkey: "",
				keyUsage: "",
				enhancedKeyUsage: "",
			},
			defaultProps: {
				children: "children",
				label: "label"
			},
			data: [],
			currentLivingId: "",
			tabList: []
		};
	},
	watch: {
		show() {

			if (this.sealInfoList.length > 0) {
				this.sealInfo = this.sealInfoList[0];
				this.data = arrayToTree(this.sealInfoList, null)
				this.currentLivingId = this.sealInfoList[0].id;
				this.$nextTick(function () {
					this.$refs.tree.setCurrentKey(this.currentLivingId)
				})
			} else {
				this.sealInfo = {
					issuerInfo: null,
					subjectInfo: null,
					start: "",
					end: "",
					hashValue: "",
					version: "",
					serial: "",
					signatureAlg: "",
					signatureHashAlg: "",
					pubkey: "",
					keyUsage: "",
					enhancedKeyUsage: "",
				};
			}
		},
		overOnLine: {
			handler(newVal) {
				if (!newVal) {
					this.tabList = ['基本信息', '详细信息', '吊销', '声明']
					this.activeNameLine = 3
				} else {
					this.tabList = ['基本信息', '详细信息', '声明']
					this.activeNameLine = 2
				}
			},
			immediate: true
		},
	},
	methods: {
		keyUsage(value) {
			if (!value) return ""
			let list = value.split(",");
			let keyList = []

			list.forEach(i => {
				keyUsageList.forEach(j => {
					if (i == j.id) keyList.push(j.name)
				})
			})
			return keyList.join("，")
		},
		enhancedKeyUsage(value) {
			if (!value) return ""
			let list = value.split(",");
			let keyList = []

			list.forEach(i => {
				enhancedKeyUsageList.forEach(j => {
					if (i == j.id) keyList.push(j.name)
				})
			})
			return keyList.join("，")
		},
		handleNodeClick(data) {
			console.log(111, data);
			this.sealInfo = data
		},
		clickTab(index) {
			this.activeName = index;
		},
		handleChoose(tabIndex) {
			this.activeTab = tabIndex;
			this.sealInfo = this.sealInfoList[tabIndex];
			this.$refs.isleft.style = `transform: translateY(${tabIndex * 40}px);`;
		},
		handleOpened() {
			this.$refs.isleft.style = "transform: translateY(0px)";
		},
		closedBtn() {
			this.clickInfo = "";
			this.activeName = 0;
			this.activeTab = 0;
			this.$emit("update:show", false);
		},
		showInfoClick(data) {
			this.clickInfo = data;
		}
	}
};
</script>

<style lang="scss" scoped>
.dialog-scrollbar {
	height: 460px;
	width: 148px;
	overflow-x: hidden;
	background: #f5f7fa;
}

.info_msg {
	color: #2EC13D;
	font-size: 14px;
	margin-bottom: 12px;

	i {
		display: inline-block;
		width: 16px;
		height: 16px;
		margin-right: 8px;
		background: url(../../../../comm/images/document-conversion/electronic/success.png) 0 0 no-repeat;
		background-size: 100%;
	}

	&.error {
		color: #FFA800;

		i {
			background: url(../../../../comm/images/document-conversion/electronic/faild.png) 0 0 no-repeat;
			background-size: 100%;
		}
	}

	&.faild {
		i {
			background: url(../../../../comm/images/document-conversion/electronic/error.png) 0 0 no-repeat;
			background-size: 100%;
		}

		color: #FF3535;
	}
}

.info_left {
	width: 240px;
	padding-left: 24px;

	.tree_box {
		border-radius: 8px;
		background: #FBFBFE;
		height: 380px;
		margin-bottom: 4px;

		h3 {
			padding: 16px 20px;
			border-bottom: 1px solid #E1E1F0;
			margin-bottom: 18px;
		}

		.el-tree {
			background: transparent;
		}
	}

	.bottom_info {
		border-radius: 8px;
		background: #FBFBFE;
		font-size: 12px;
		line-height: 24px;
		color: #12196A;
		padding: 12px;

		.info {
			color: #2EC13D;

			i {
				display: inline-block;
				width: 16px;
				height: 16px;
				background: url(../../../../comm/images/document-conversion/electronic/success.png) 0 0 no-repeat;
				background-size: 100%;
				margin-right: 8px;
			}
		}
	}

}

.left-tab {
	overflow: hidden;
	width: 100%;
	height: auto;
	position: relative;

	li.is-left {
		position: absolute;
		top: 0;
		left: 0;
		width: 2px;
		height: 40px;
		background-color: #409eff;
		z-index: 1;
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		list-style: none;
		padding: 0;
		margin: 0;
	}

	li {
		height: 40px;
		line-height: 40px;
		padding-left: 20px;
		display: flex;
		align-items: center;
		cursor: pointer;
		color: #8b97af;
		font-size: 14px;

		&:hover {
			p {
				color: #14a8f0;
			}
		}

		img {
			width: 24px;
			margin-right: 6px;
		}

		p {
			flex: 1;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			word-break: break-all;
		}
	}

	li.active {
		background-color: #fff;
		color: #14a8f0;
	}
}

.tab_box {
	display: flex;
	align-items: center;
	margin-bottom: 16px;

	.tab_item {
		font-size: 16px;
		color: #7378B5;
		line-height: 24px;
		height: 32px;
		margin: 0 12px;
		cursor: pointer;

		&.active {
			color: #12196A;
			border-bottom: 2px solid #14a8f0;

		}
	}
}

.info_box,
.time_box {
	border-radius: 2px 2px 0px 0px;
	border: 1px solid #e4e6eb;
	height: 442px;
	overflow-y: auto;
	padding: 16px;
	font-size: 14px;
	line-height: 24px;
}

.info_diaoxiao {
	height: 413px;
}

.time_box {
	height: 106px;
	margin-top: 16px;
	padding: 8px 16px;
}

.dialog_main {
	position: relative;
	padding: 0 24px;
	height: 580px;
	flex: 1;

	&.active {
		width: 492px;
	}

	.dialog-footer {
		margin-top: 38px;
	}

	.info_box {
		position: relative;

		ul li {
			font-size: 14px;
			line-height: 24px;
			padding: 0 8px;
			margin-bottom: 16px;
			cursor: pointer;
			display: flex;

			&:hover {
				background: rgba(198, 206, 214, 0.2);
			}

			&:focus,
			&:active {
				background: rgba(198, 206, 214, 0.4);
			}

			&:first-child {
				cursor: default;
				color: #b7bfd0;

				&:hover,
				&:focus,
				&:active {
					background: none;
				}
			}

			.info_lable {
				width: 88px;
			}

			.info_content {
				flex: 1;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				display: block;
			}
		}

		.info_bottom {
			position: absolute;
			bottom: 16px;

			p {
				color: #7378B5;
				font-size: 12px;
				line-height: 24px;
				margin-bottom: 18px;
			}

			.botton {
				span {
					color: #14a8f0;
					font-size: 14px;
					cursor: pointer;

					&.line {
						padding: 0 8px;
						color: #000;
						cursor: default;
					}
				}
			}
		}
	}

	.certificate_info {
		p {
			font-size: 14px;
			margin-bottom: 16px;
		}

		ul li {
			color: #12196A;
			cursor: default;

			&:hover,
			&:focus,
			&:active {
				background: none;
			}

			&:first-child {
				color: #12196A;
			}

			.info_lable {
				width: 100px;
				line-height: 24px;
				font-weight: 600;
			}

			.info_content {
				flex: 1;
				overflow-y: auto;
				display: block;
				line-height: 24px;
				white-space: inherit;
				text-overflow: inherit;

				&::-webkit-scrollbar {
					display: none;
				}
			}
		}
	}
}
.tree-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/attestationPage/components/certificateInfo.vue